import { Expose, Type, Exclude } from 'class-transformer';

import { SnModel } from '@lib/common/models';
import { ISnIsSharable } from '@lib/share';

import { SnContentType, IHasContentType } from '../base';
import { FususRegionCode } from '../constants';
import { SnOrganization } from '../organization';
import { SnShareInfo, SnSharePermissions } from '../share';

export class SnTag extends SnModel implements ISnIsSharable, IHasContentType {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnOrganization)
  public organization: SnOrganization;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public count: number;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public isShared: boolean;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnShareInfo)
  public shareInfo: SnShareInfo;

  public contentType = SnContentType.Tag;

  @Expose()
  public isSystem: boolean;

  @Expose()
  public region?: FususRegionCode;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  get canEdit(): boolean {
    return !this.isShared || this.shareInfo.permissions === SnSharePermissions.Edit;
  }

  get isOwned(): boolean {
    return !this.isShared || this.shareInfo.direction === 'Out';
  }

  get icon(): string {
    switch (this.contentType) {
      case SnContentType.Camera:
        return 'videocam';
      case SnContentType.Location:
        return 'location_city';
      case SnContentType.Grid:
        return 'apps';
    }
  }
}
